import { createSlice } from "@reduxjs/toolkit";

// Define a type for the slice state
interface IPricePerUnitCurrency {
  data: Array<ICurrency>;
  pageSize: number;
  pageNumber: number;
  totalCount: number;
  showLoading: ILoading;
  currencyDetails: IPricePerUnitCurrency | null;
}

// Define the initial state using that type
const initialState: IPricePerUnitCurrency = {
  data: [],
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  currencyDetails: null,
};

export const pricePerUnitCurrencySlice = createSlice({
  name: "pricePerUnitCurrency",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.showLoading = {
        sourceAction: action.payload.sourceAction,
        state: true,
      };
    },
    resetLoading: (state, action) => {
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
    },
    replacePricePerUnitCurrency: (state, action) => {
      state.data = action.payload.data;
      state.pageSize = action.payload.pageSize;
      state.pageNumber = action.payload.pageNumber;
      state.totalCount = action.payload.totalCount;
    },
    setCurrencyDetails: (state, action) => {
      state.currencyDetails = action.payload.data;
    },
  },
});

export const pricePerUnitCurrencyActions = pricePerUnitCurrencySlice.actions;

export default pricePerUnitCurrencySlice.reducer;
